/* TODO: update according to reality */

import translate from "src/functions/translate";

function optionsUnit(lang: string) {
  return [
    { title: translate(`per 15 minutes`, lang), value: `minutes_15` },
    { title: translate(`per 20 minutes`, lang), value: `minutes_20` },
    { title: translate(`per 30 minutes`, lang), value: `minutes_30` },
    { title: translate(`per 40 minutes`, lang), value: `minutes_40` },
    { title: translate(`per 45 minutes`, lang), value: `minutes_45` },
    { title: translate(`per hour`, lang), value: `hours_1` },
    { title: translate(`per hour and quarter`, lang), value: `hours_1_15` },
    { title: translate(`per hour and half`, lang), value: `hours_1_30` },
    { title: translate(`per two hours`, lang), value: `hours_2` },
    {
      title: translate(`per two hours and quarter`, lang),
      value: `hours_2_30`,
    },
    { title: translate(`per three hours`, lang), value: `hours_3` },
    { title: translate(`per half day`, lang), value: `hours_4` },
    { title: translate(`per five hours`, lang), value: `hours_5` },
    { title: translate(`per six hours`, lang), value: `hours_6` },
    { title: translate(`per seven hours`, lang), value: `hours_7` },
    { title: translate(`per day`, lang), value: `days_1` },
    { title: translate(`per two days`, lang), value: `days_2` },
    { title: translate(`per three days`, lang), value: `days_3` },
    { title: translate(`per four days`, lang), value: `days_4` },
    { title: translate(`per five days`, lang), value: `days_5` },
    { title: translate(`per six days`, lang), value: `days_6` },
    { title: translate(`per weekend`, lang), value: `weekend` },
    { title: translate(`per week`, lang), value: `weeks_1` },
    { title: translate(`per two weeks`, lang), value: `weeks_2` },
    { title: translate(`per three weeks`, lang), value: `weeks_3` },
    { title: translate(`per month`, lang), value: `months_1` },
    { title: translate(`per two months`, lang), value: `months_2` },
    { title: translate(`per three months`, lang), value: `months_3` },
  ];
}

export default optionsUnit;
